<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
  <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <h2 class="noMarginHeader">
      <mat-icon>bar_chart</mat-icon> Household Interactions with Approval Needed
    </h2><br />
  </div>
</div>
<div fxLayout="row wrap" class="matero-row" fxLayoutAlign="space-between start">
  <div fxFlex="100" fxFlex.lt-sm="100" class="matero-col" fxLayoutAlign="start">
    <small>Households that have had an interaction that needs approval. </small><br />
  </div>
</div>

<mat-card *ngIf="loading">
  <span>Loading</span><br />
  <mat-progress-bar mode="query"></mat-progress-bar>
</mat-card>
<!-- List of Letter Tasks -->
<mat-card>
  <div [fxFlex.gt-sm]="100" [fxFlex]="100" class="matero-col" style="overflow-x: auto;">
    <br />
    <mat-table [dataSource]="dataSource" matSort #TableSort="matSort" class="mat-elevation-z8"
      style="overflow-x: auto;">
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      
      <ng-container matColumnDef="HouseholdId">
        <mat-header-cell *matHeaderCellDef mat-sort-header>OHA Household Id</mat-header-cell>
        <mat-cell *matCellDef="let result">
          <a (click)="editHousehold(result.householdId)"
            title="Edit Household {{result.householdId}}" style="cursor: pointer;">{{result.householdId}}</a>
        </mat-cell>
      </ng-container>
      <ng-container matColumnDef="Type">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Type</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.type}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Result">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Result</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.result}}
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Comment">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Comment</mat-header-cell>
        <mat-cell *matCellDef="let result">
           {{result.comment}} 
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="LastUpdated">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Update Date</mat-header-cell>
        <mat-cell *matCellDef="let result">
          {{result.lastUpdated | date: 'MM/dd/yyyy'}}
        </mat-cell>
      </ng-container>


    </mat-table>
    <br />
    <mat-paginator [pageSizeOptions]="[10, 20, 50]" #TablePaginator="matPaginator" showFirstLastButtons></mat-paginator>
  </div>
</mat-card>
